import Footer from "../components/footer";
import Header from "../components/header"
import SideNav from "../components/sidenav"
import PageHeader from "../components/pageHeader";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Link , useNavigate} from "react-router-dom";

const BlogAll = () =>{

    const navigate = useNavigate();
        const [dataBlog, setDataBlog] = useState([]);
    
        // Function to Fetch data from API for dropdown
        const fetchData = async (url, setData) => {
    
            try {
                const response = await fetch(url);
                const data = await response.json();
                setData(data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
    
        };
    
        useEffect(() => {
            fetchData('https://igapi.heuristticminds.com/api/BlogList/Get-GetBlogListAll', setDataBlog);
    
        }, [dataBlog]);
    

         const columns = [
                {
                    name: "Title",
                    cell: row => (
                        <div style={{ wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                            {row.title}
                        </div>
                    ),
                    width: "200px",
                },
                {
                    name: "Content",
                    cell: (row) => (
                        <div style={{ whiteSpace: "pre-line", width: "1350px" }} dangerouslySetInnerHTML={{ __html: row.contents }} />
                    ),
                    allowOverflow: true,
                    maxWidth:"550px",
                },
                {
                    name: "Date",
                    selector: row => new Date(row.createdOn).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }),           
                    allowOverflow: true,
                    maxWidth:"150px",
                },
                {
                    name: "Action",
                    cell: (row) => (
                        <div>
                            <Link to={``} onClick={() => onStatusClick(row.id)}>
                                <img
                                    src={row.status === 1 ? "/images/ImgActive.gif" : "/images/ImgInActive.gif"}
                                    alt="Change Status"
                                    title="Change Status"
                                    style={{ width: "50px", height: "25px" }}
                                />
                            </Link>       
                           
                        </div>
                    ),
                    maxWidth:"100px",
        
                },
            ];


            const onStatusClick = async (id) =>{
        
                const confirmed = window.confirm("Are you sure you want to change status?");
                if (!confirmed) {
                    return; // If not confirmed, return early without deleting
                }
                try {
                    
                    const response = await fetch('https://igapi.heuristticminds.com/api/BlogList/Update-ChangeBlogStatus?id=' + id, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    });
                    if (response.ok) {
                        fetchData('https://igapi.heuristticminds.com/api/BlogList/Get-GetBlogListAll', setDataBlog);
                    }
                }
                catch {
                }
        
            }

    return(
        <>
        <Header />
        <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">
                    <PageHeader name='Exhibition' icon='bi bi-activity' />
                    <div className="container-xl px-4">
                        <div className="row">
                            <div className="col-lg-12 mb-4">
                                <div className="card mb-4">
                                    <div className="card-header">Bolgs</div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <a href="/addBlog" className="btn btn-primary"><i className="bi bi-plus-circle-fill"></i> Add Blog</a>
                                            </div>
                                        </div>
                                        <div className="pb-2">                                    
                                            <div className="ps-2 pe-2">
                                                <DataTable 
                                                    columns={columns}
                                                    data={dataBlog}
                                                /> 
                                            </div>   
                                        </div>
                                    </div>
                                </div>
                            </div>                    
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    )

};
export default BlogAll;